import {isDefined} from "../../libs/utils/epic.utils";

// see SearchCorrespondenceItem
export class CorrespondenceDto {

  public readonly id!: string;
  public readonly completed!: boolean;
  public readonly created!: Date;

  constructor(init?: Partial<CorrespondenceDto> | undefined) {
    Object.assign(this, init);
    if (isDefined(init?.created)) {
      this.created = new Date(init.created);
    }
  }

  public isEditable(): boolean {
    return false;
  }
}
